// ---------------------------------------------------------------------------
// DiCharts SDK – Event Emitter
// ---------------------------------------------------------------------------

export interface WidgetEventMap {
  timeframeChange: [timeframe: import('./types').TimeframeInfo];
  styleChange: [style: import('./types').CandleStyle];
  themeChange: [theme: 'dark' | 'light'];
  indicatorAdd: [indicatorId: string];
  indicatorRemove: [indicatorId: string];
  layoutChange: [layout: string];
  tick: [tick: import('./types').TickInput];
  ready: [];
}

export type WidgetEventName = keyof WidgetEventMap;

type Listener<T extends unknown[]> = (...args: T) => void;

export class EventEmitter {
  private listeners = new Map<string, Set<Function>>();

  on<K extends WidgetEventName>(event: K, fn: Listener<WidgetEventMap[K]>): void {
    let set = this.listeners.get(event);
    if (!set) { set = new Set(); this.listeners.set(event, set); }
    set.add(fn);
  }

  off<K extends WidgetEventName>(event: K, fn: Listener<WidgetEventMap[K]>): void {
    this.listeners.get(event)?.delete(fn);
  }

  emit<K extends WidgetEventName>(event: K, ...args: WidgetEventMap[K]): void {
    const set = this.listeners.get(event);
    if (!set) return;
    for (const fn of set) {
      (fn as Listener<WidgetEventMap[K]>)(...args);
    }
  }

  removeAllListeners(): void {
    this.listeners.clear();
  }
}
